const searchContact = (input, contacts) => {
	const filteredContacts = contacts.filter((contact) => {
		return (
			contact.firstName.toLowerCase().includes(input?.toLowerCase()) ||
			contact.lastName.toLowerCase().includes(input?.toLowerCase())
		);
	});
	return filteredContacts;
};

export default searchContact;
